"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _toConsumableArray2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _group = require("@/api/_homeCloudPlatform/group/group.js");
var _memberManage = require("@/api/_homeCloudPlatform/member/memberManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _file = require("@/api/file");
var _region = require("@/api/region");
var _vuex = require("vuex");
var _xlsx = _interopRequireDefault(require("xlsx"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO
// const formModel = {
//   enclosure: [],
//   type: "1"
// }

// const phoneValidator = (rule, value, callBack) => {
//   const reg = /^[1][0-9]{10}$/
//   if (value) {
//     if (!reg.test(value)) {
//       callBack('请输入正确的联络人手机号')
//     } else {
//       callBack()
//     }
//   } else {
//     callBack()
//   }
// }
var formModel = {
  province_code: '',
  city_code: '',
  district_code: '',
  store_devices: [],
  store_health_users: [{
    name: ""
  }],
  valid_records: [{
    stage: 1,
    comment: ''
  }]
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['name'])), {}, {
    rules: function rules() {
      var _this2 = this;
      return {
        store_name: [{
          required: true,
          message: '请输入店铺名称',
          trigger: 'blur'
        }],
        group: [{
          required: true,
          message: '请选择机构名称',
          trigger: 'change'
        }],
        contact_name: [{
          required: true,
          message: '请输入联络人名称',
          trigger: 'blur'
        }],
        contact_phone: [{
          required: true,
          message: '请输入联络人手机',
          trigger: 'blur'
        }],
        store_valid_type: [{
          required: true,
          message: '请选择合作形式',
          trigger: 'change'
        }],
        store_identifier: [{
          required: true,
          message: '请输入18位法定身份识别码或信用代码',
          trigger: 'blur'
        }],
        store_online_status: [{
          required: true,
          message: '请选择上线状态',
          trigger: 'change'
        }],
        location: [
        // {required: true,  message: '请选择服务省区市',},
        {
          validator: function validator(rule, value, callBack) {
            // TODO 验证,网址规则
            if (!_this2.formModel.province_code || !_this2.formModel.city_code || !_this2.formModel.district_code) {
              callBack('请选择完整服务省区市');
            } else {
              callBack();
            }
          },
          trigger: 'submit'
        }],
        address: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        staff_size: [{
          required: true,
          message: '请输入员工规模',
          trigger: 'blur'
        }],
        is_service_fee: [{
          required: true,
          message: '请选择是否需额外支付服务费',
          trigger: 'change'
        }],
        // managerAccount: [
        //   { required: true, message: '请输入11位会员帐号(手机号)', trigger: 'blur' },
        // ], 
        name: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (value) {
              var arr = [];
              // 找重复
              _this2.formModel.store_health_users.forEach(function (item, i) {
                if (item.name && value.name === item.name) arr.push(item.name);
              });
              if (!value.name) {
                //没有姓名
                callBack('请输入名字');
              } else {
                if (arr.length > 1) {
                  //有姓名但重复
                  callBack('名字重复');
                } else {
                  callBack();
                }
              }
            } else {
              callBack();
            }
          }
        },
        mobile: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (value) {
              var arr = [];
              // 找重复
              _this2.formModel.store_health_users.forEach(function (item) {
                if (item.mobile && value.mobile === item.mobile)
                  // console.log('item.mobile:'+item.mobile)
                  arr.push(item.mobile);
              });
              if (!value.mobile) {
                //没有手机号
                callBack('请输入手机号');
              } else {
                if (arr.length > 1) {
                  //有手机号但重复
                  callBack('手机号重复');
                } else {
                  callBack();
                }
              }
            } else {
              callBack();
            }
          }
        }
        // wechat: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arr = []
        //     // 找重复
        //     this.formModel.store_health_users.forEach(item => {
        //       if(item.wechat && value.wechat === item.wechat)
        //         arr.push(item.wechat)
        //     })
        //     if(!value.wechat){ //没有wechat
        //       callBack('请输入wechat')
        //     }else{
        //       if(arr.length > 1){ //有wechat但重复
        //         callBack('wechat重复')
        //       }else{
        //         callBack()
        //       }
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},  
        // device_menu: { required: true,
        //   validator: (rule, value, callBack) => {  
        //     if (!value.device_category_level_1_code || !value.device_category_level_2_code ) {
        //         callBack('请选择完整设备分类')
        //     } else {
        //       callBack()
        //     }          
        //   }
        // },
        // device_number: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arr = []
        //     // 找重复
        //     this.formModel.store_devices.forEach(item => {
        //       if(item.device_number && value.device_number === item.device_number)
        //         arr.push(item.device_number)
        //     })
        //     if(!value.device_number){ //没有设备编号
        //       callBack('请输入设备编号')
        //     }else{
        //       if(arr.length > 1){ //有编号但重复
        //         callBack('设备编号重复')
        //       }else{
        //         callBack()
        //       }
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},
        // device_description: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     if(!value.device_description) {
        //       callBack('请输入设备描述')
        //     } else {
        //       callBack()
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},
        // default_health_user: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arrDedault = this.formModel.store_health_users.filter(item => {
        //       return item.mobile === value
        //     })
        //     console.log('arrDedault',arrDedault)
        //     console.log('default_store_health_user',this.default_store_health_user)
        //     if(arrDedault.length == 0){
        //       this.default_store_health_user = ''
        //       callBack('找不到该手机号的健管师，请重新选择')
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},  
        // promote_content: [
        //   { required: true, message: '请输入宣传信息', trigger: 'blur' },
        // ],
        // group_owner: [
        //   { required: true, message: '请输入经营者名称', trigger: 'blur' },
        // ],         
        // file_path: [
        //   { required: true, message: '请输入固件档案阿里云地址', trigger: 'blur' },
        //   { max: 150, message: '输入长度不能超过150位' },
        //   { validator: (rule, value, callBack) => {
        //     // TODO 验证,网址规则
        //     // if (value) {
        //     //   callBack('多笔请使用「,」分隔')
        //     // } else {
        //     callBack()
        //     // }
        //   }, trigger: 'submit'
        //   }
        // ],
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '查看';
          break;
        case 'edit':
          type = '编辑';
          break;
        case 'review':
          type = '初审';
          break;
        case 'approval':
          type = '复审';
          break;
        case 'add':
          type = '新增';
          break;
      }
      return "".concat(type, "\u5E97\u94FA");
    },
    discRules: function discRules() {
      return {
        amount: [{
          required: true,
          message: '请输入增减盘次数'
        }],
        note: [{
          required: true,
          message: '请填写备注'
        }]
      };
    },
    deviceRules: function deviceRules() {
      var _this3 = this;
      return {
        device_numbers: [{
          validator: function validator(rule, value, callBack) {
            if (!_this3.deviceFormModel.device_numbers) {
              callBack('请填入设备编码');
            } else {
              callBack();
            }
          },
          trigger: 'submit'
        }]
        // disc_numbers: [
        //   { validator: (rule, value, callBack) => {
        //     if (!this.deviceFormModel.device_numbers) {
        //       callBack('设备或控释盘编码请至少择一填入')
        //     } else {
        //       callBack()
        //     }
        //   }, trigger: 'submit'
        //   }
        // ],
      };
    },
    formattedDeviceList: function formattedDeviceList() {
      if (this.deviceList.device_numbers !== undefined) {
        return this.deviceList.device_numbers.map(function (number) {
          return {
            device_id: number
          };
        });
      }
    },
    formattedDiscList: function formattedDiscList() {
      if (this.deviceList.disc_numbers !== undefined) {
        return this.deviceList.disc_numbers.map(function (number) {
          return {
            disc_id: number
          };
        });
      }
    } // stage1Comment: { //找初审备注
    //   get(){
    //     const stage1Record = this.formModel.valid_records.find(record => record.stage === 1);
    //     return stage1Record ? stage1Record.comment : '';
    //   },
    //   set(value) {
    //     const stage1RecordIndex = this.formModel.valid_records.findIndex(record => record.stage === 1);
    //     if (stage1RecordIndex !== -1) {
    //       this.formModel.valid_records[stage1RecordIndex].comment = value;
    //     } else {
    //       // 如果 stage 为 1 的记录不存在，则创建一个新的记录
    //       this.formModel.valid_records.push({ stage: 1, comment: value });
    //     }
    //   }
    // },
    // stage2Comment: { //找复审备注
    //   get(){
    //     const stage2Record = this.formModel.valid_records.find(record => record.stage === 2);
    //     return stage2Record ? stage2Record.comment : '';
    //   },
    //   set(value) {
    //     const stage2RecordIndex = this.formModel.valid_records.findIndex(record => record.stage === 2);
    //     if (stage2RecordIndex !== -1) {
    //       this.formModel.valid_records[stage2RecordIndex].comment = value;
    //     } else {
    //       // 如果 stage 为 1 的记录不存在，则创建一个新的记录
    //       this.formModel.valid_records.push({ stage: 2, comment: value });
    //     }
    //   }
    // },
  }),
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        //仅编辑可见，其他状态反灰
        this.disabled = val !== 'edit' && val !== 'add';
        console.log('dialogType', this.dialogType);
      }
    }
  },
  data: function data() {
    return {
      activeDeviceTab: 'device',
      deviceList: [],
      //formModel,
      formModel: {
        province_code: '',
        city_code: '',
        district_code: '',
        store_devices: []
        // store_health_users: [{name:""}],
        // valid_records: [{stage:1,comment:'xx'},{stage:2,comment:'oo'}]
      },
      activeName: 'basicInfo',
      validStatusOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 0,
        display_name: '待审核'
      }, {
        key: 1,
        display_name: '待复审'
      }, {
        key: 2,
        display_name: '通过'
      }, {
        key: 3,
        display_name: '拒绝'
      }],
      onlineStatusOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 0,
        display_name: '下架'
      }, {
        key: 1,
        display_name: '上架'
      }],
      validTypeOptions: [
      // { key: 'all', display_name: '全部' },
      {
        key: 1,
        display_name: '个人合作'
      }, {
        key: 2,
        display_name: '企业合作'
      }],
      storeSizeOptions: [
      // { key: 'all', display_name: '全部' },
      {
        key: 1,
        display_name: '一级'
      }, {
        key: 2,
        display_name: '二级'
      }, {
        key: 3,
        display_name: '三级'
      }, {
        key: 4,
        display_name: '四级'
      }, {
        key: 5,
        display_name: '五级'
      }],
      yesOrNoOption: [{
        key: false,
        display_name: '否'
      }, {
        key: true,
        display_name: '是'
      }],
      listQuery: {
        page: 1,
        page_size: 20
        // group_status: 1,
        // type: 1
      },
      defaultOrdering: '-created_at',
      // 默认排序,依创建时间递减
      disabled: false,
      tableData: {},
      listLoading: true,
      dialogVisible: false,
      dialogType: 'view',
      groupOptions: [],
      //合作机构选项
      deviceL1Menu: [],
      //检测设备分类表一级编码清单
      deviceL2Menu: [],
      //检测设备分类表二级编码清单
      // 图片 / 档案 API
      previewImg: '',
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      // 县市区
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      province_code: '',
      city_code: '',
      district_code: '',
      stage1Comment: '',
      //初审备注
      stage2Comment: '',
      //复审备注
      managerName: '',
      //店长名称
      managerAccount: '',
      //店长帐号
      deviceL1All: [],
      //所有设备分类一级选项
      deviceL2All: [],
      //所有设备分类二级选项
      deviceL2Data: [],
      //关联设备分类二级选项
      discRecordData: [],
      // 盤次纪录
      discRecordQuery: {
        online_order: "",
        page: 1,
        page_size: 10,
        count: 0,
        ordering: '-created_at',
        switch: true
      },
      discFormModel: {
        amount: 0
      },
      // 
      deviceFormModel: {
        device_numbers: '',
        disc_numbers: ''
      },
      // 
      isDiscShow: false,
      isDeviceShow: false
      //healthUserList:[] //健管师清单（不含新增无id）
    };
  },
  created: function created() {
    this.getList();
    this.getGroupList();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getDeviceL1All();
    this.getDeviceL2All();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this4 = this;
      //店铺列表
      this.listLoading = true;
      (0, _group.getStoreList)(this.handleQuery()).then(function (res) {
        console.log('getStoreList res', res);
        if (res.results) {
          _this4.tableData = res || [];
        }
        _this4.listLoading = false;
      });
    },
    getGroupList: function getGroupList() {
      var _this5 = this;
      //机构选项
      (0, _group.getGroupList)({
        page: 1,
        page_size: 1
        // group_status:1
      }).then(function (data) {
        if (!data.count) return;
        (0, _group.getGroupList)({
          page_size: data.count
          // group_status:1
        }).then(function (res) {
          _this5.groupOptions = res.results || [];
          // console.log('groupOptions',this.groupOptions)
        });
      });
    },
    getDeviceL1All: function getDeviceL1All() {
      var _this6 = this;
      //检测设备分类表一级编码清单
      (0, _group.getDeviceL1Menu)().then(function (res) {
        _this6.deviceL1All = res.results || [];
        // console.log('deviceL1All',this.deviceL1All)
      });
    },
    getDeviceL2All: function getDeviceL2All() {
      var _this7 = this;
      //检测设备分类表二级编码清单
      (0, _group.getDeviceL2Menu)({
        // category_level_1_code:1
      }).then(function (res) {
        _this7.deviceL2All = res.results || [];
        // console.log('deviceL2All',this.deviceL2All)
      });
    },
    getStoreDiscRecord: function getStoreDiscRecord(id) {
      var _this8 = this;
      //查询合作机构店铺盘次
      this.discRecordQuery.group_store = id;
      (0, _group.getStoreDiscRecord)(this.discRecordQuery).then(function (res) {
        _this8.discRecordQuery.count = res.count;
        _this8.discRecordData = res.results || [];
      });
    },
    getStoreDeviceDisc: function getStoreDeviceDisc(id) {
      var _this9 = this;
      //查询店铺设备/盘清单
      (0, _group.getStoreDeviceDisc)({
        id: id
      }).then(function (res) {
        // let deviceDisc = res.results || []
        _this9.deviceList = res.results[0].devices_disc;
      });
    },
    //操作纪录paginaion
    handleRecordList: function handleRecordList() {
      var _this10 = this;
      (0, _group.getStoreDiscRecord)(this.discRecordQuery).then(function (res) {
        _this10.discRecordQuery.count = res.count;
        _this10.discRecordData = res.results || [];
        _this10.listLoading = false;
      });
    },
    deviceL1Change: function deviceL1Change(val, index) {
      var _this11 = this;
      console.log('deviceL1Change val', val);
      // 清空当前设备的L2选项
      this.formModel.store_devices[index].device_category_level_2_code = '';
      // 如果新添加的设备的deviceL2Data属性未定义，则手动将其初始化为空数组
      if (this.formModel.store_devices[index].deviceL2Data === undefined) {
        this.$set(this.formModel.store_devices[index], 'deviceL2Data', []);
      }
      // 依据设备筛选关联L1的L2选项
      var selectedL1 = val;
      var associatedL2Options = this.deviceL2All.filter(function (item) {
        return item.category_level_1_code === selectedL1;
      });
      // 将关联的L2选项设置给当前设备
      this.$set(this.formModel.store_devices[index], 'deviceL2Data', (0, _toConsumableArray2.default)(associatedL2Options));
      // 使用 $nextTick()来确保视图的更新
      this.$nextTick(function () {
        _this11.$forceUpdate();
      });
      // console.log('associatedL2Options',associatedL2Options)
      // console.log('this.formModel.store_devices[index]',this.formModel.store_devices[index])
    },
    getCurrentDateTime: function getCurrentDateTime() {
      // 取得当前时间
      var chinaTime = new Date();
      // 转换成中国时间 (UTC+8)
      chinaTime.setUTCHours(chinaTime.getUTCHours());
      // 格式化时间
      var year = chinaTime.getFullYear();
      var month = (chinaTime.getMonth() + 1).toString().padStart(2, '0');
      var day = chinaTime.getDate().toString().padStart(2, '0');
      var hours = chinaTime.getHours().toString().padStart(2, '0');
      var minutes = chinaTime.getMinutes().toString().padStart(2, '0');
      var seconds = chinaTime.getSeconds().toString().padStart(2, '0');
      // 产生格式化后的字串
      var formattedTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
      console.log('getCurrentDateTime:', formattedTime);
      return formattedTime;
    },
    getGroupName: function getGroupName(val) {
      //转换机构名
      var arr = this.groupOptions.filter(function (item) {
        return item.id == val;
      });
      return arr.length ? arr[0].group_name : '-';
    },
    getValidTypeName: function getValidTypeName(val) {
      //转换认证类型名
      var arr = this.validTypeOptions.filter(function (item) {
        return item.key == val;
      });
      return arr.length ? arr[0].display_name : '-';
    },
    getStoreSizeName: function getStoreSizeName(val) {
      //转换店铺规模名
      var arr = this.storeSizeOptions.filter(function (item) {
        return item.key == val;
      });
      return arr.length ? arr[0].display_name : '-';
    },
    getValidStatusName: function getValidStatusName(val) {
      //转换认证状态名
      var arr = this.validStatusOptions.filter(function (item) {
        return item.key == val;
      });
      return arr.length ? arr[0].display_name : '-';
    },
    getOnlineStatusName: function getOnlineStatusName(val) {
      //转换上线状态名
      var arr = this.onlineStatusOptions.filter(function (item) {
        return item.key == val;
      });
      return arr.length ? arr[0].display_name : '-';
    },
    getYesOrNo: function getYesOrNo(val) {
      //转换boolean是否选项
      var arr = this.yesOrNoOption.filter(function (item) {
        return item.key + '' === val + '';
      });
      return arr.length ? arr[0].display_name : '-';
    },
    handleClick: function handleClick(tab, event) {
      //切换dialog tab页籤
      console.log('handleClick', tab, event);
      console.log('activeName', this.activeName);
      setTimeout(function () {
        // this.activeDeviceTab = this.activeName
        document.querySelector('.el-tabs__content').scrollTop = 0;
      });
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      // 认证状态若为全部不带条件参数
      if (query.store_valid_status === '' || query.store_valid_status === 'all') {
        query.store_valid_status = function () {
          return;
        }();
      }
      // 上线状态若为全部不带条件参数
      if (query.store_online_status === '' || query.store_online_status === 'all') {
        query.store_online_status = function () {
          return;
        }();
      }
      return query;
    },
    handleAdd: function handleAdd() {
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
    },
    handleView: function handleView(scope) {
      var _this12 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      // Object.assign({}, scope.row)
      this.handleInitData();
      this.getStoreDiscRecord(scope.row.id);
      this.getStoreDeviceDisc(scope.row.id);
      // this.tableData.results[0] = this.formModel
      // this.ownerName = this.formModel.group_operator_name
      this.dialogVisible = true;
      this.dialogType = 'view';
      this.activeName = 'basicInfo';
      this.$nextTick(function () {
        _this12.$refs['Form'].clearValidate();
      });
      console.log('handleView formModel', this.formModel);
    },
    handleEdit: function handleEdit(scope) {
      var _this13 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.getStoreDiscRecord(scope.row.id);
      this.getStoreDeviceDisc(scope.row.id);
      // if (this.formModel.members.length==0) {
      //   this.formModel.members = [{name: ""}]
      // }
      // this.ownerName = this.formModel.group_operator_name
      this.dialogVisible = true;
      this.dialogType = 'edit';
      this.activeName = 'basicInfo';
      this.$nextTick(function () {
        _this13.$refs['Form'].clearValidate();
      });
      console.log('handleEdit formModel', this.formModel);
    },
    handleReview: function handleReview(scope) {
      var _this14 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogVisible = true;
      this.dialogType = 'review';
      this.activeName = 'basicInfo';
      this.$nextTick(function () {
        _this14.$refs['Form'].clearValidate();
      });
      console.log('handleReview formModel', this.formModel);
    },
    handleApproval: function handleApproval(scope) {
      var _this15 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogVisible = true;
      this.dialogType = 'approval';
      this.activeName = 'basicInfo';
      this.$nextTick(function () {
        _this15.$refs['Form'].clearValidate();
      });
      console.log('handleApproval formModel', this.formModel);
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      if (this.listQuery.device_name == '') {
        delete this.listQuery.device_name;
      }
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size
      };
      this.getList();
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // 以上新增，我是分隔线
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this16 = this;
        var action,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              action = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  // if(this.ownerName == '') {
                  //   this.$message({
                  //     message: '请输入正确会员帐号(手机号)',
                  //     type: 'warning'
                  //   });        
                  //   return false;      
                  // }

                  // 处理建管师被移除
                  // if(this.formModel.store_health_users[0].name =='') {
                  //   this.formModel.store_health_users = []
                  // }

                  // 处理图片路径
                  if (_this16.previewImg.path) {
                    _this16.formModel.license = _this16.previewImg.path;
                  } else {
                    delete _this16.formModel.license;
                  }
                  // 处理设备多余资料：将每个设备的deviceL2Data字段从formModel.store_devices中删除
                  _this16.formModel.store_devices.forEach(function (device) {
                    delete device.deviceL2Data;
                  });
                  // 在提交前检查每个设备的设备编号是否填写
                  // const isDeviceNumberEmpty = this.formModel.store_devices.some(device => !device.device_number);//回传布林一个以上为true
                  // if (isDeviceNumberEmpty) {
                  //   return this.$message.error('请输入完整的设备信息');
                  // }

                  // 储存
                  if (_this16.dialogType === 'add') {
                    // 店铺认证状态直接通过
                    _this16.formModel.store_valid_status = 2;
                    if (_this16.formModel.store_devices && _this16.formModel.store_devices[0].device_category_level_1_code == "") {
                      _this16.formModel.store_devices = [];
                    }
                    if (_this16.formModel.store_health_users[0].name == "") {
                      _this16.formModel.store_health_users = [];
                    }
                    (0, _group.addStoreConsole)(_this16.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  } else if (_this16.dialogType === 'edit') {
                    console.log('confirm edit', _this16.formModel);
                    if (_this16.formModel.store_devices[0].device_category_level_1_code == "") {
                      _this16.formModel.store_devices = [];
                    }
                    // if (this.formModel.store_health_users[0].name=="") {
                    //   this.formModel.store_health_users = []
                    // }
                    (0, _group.updateStoreList)(_this16.formModel.id, _this16.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this16.dialogType === 'review') {
                    // 初审：切换认证状态 & 写入备注valid_records
                    // 状态: 0:待审核;1:待复审;2:通过;3:拒绝
                    var params = {
                      store_valid_status: _this16.formModel.store_valid_status,
                      valid_records: _this16.formModel.valid_records || []
                      // store_devices: this.formModel.store_devices || []
                    };
                    var record = {
                      stage: 1,
                      comment: _this16.stage1Comment,
                      created_at: _this16.getCurrentDateTime(),
                      valid_user: _this16.$store.getters.name
                    };
                    if (action === 'reviewPass') {
                      params.store_valid_status = 1;
                    } else {
                      params.store_valid_status = 3;
                    }
                    params.valid_records.push(record);
                    console.log('review params', params);
                    (0, _group.updateStoreList)(_this16.formModel.id, params).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '送出成功',
                        type: 'success'
                      });
                    });
                  } else if (_this16.dialogType === 'approval') {
                    // 复审：切换认证状态 & 写入备注valid_records
                    // 状态: 0:待审核;1:待复审;2:通过;3:拒绝
                    var _params = {
                      store_valid_status: _this16.formModel.store_valid_status,
                      valid_records: _this16.formModel.valid_records || []
                      // store_devices: this.formModel.store_devices || []
                    };
                    var _record = {
                      stage: 2,
                      comment: _this16.stage2Comment,
                      created_at: _this16.getCurrentDateTime(),
                      valid_user: _this16.$store.getters.name
                    };
                    if (action === 'approvalPass') {
                      _params.store_valid_status = 2;
                    } else {
                      _params.store_valid_status = 3;
                    }
                    _params.valid_records.push(_record);
                    console.log('approval params', _params);
                    (0, _group.updateStoreList)(_this16.formModel.id, _params).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '送出成功',
                        type: 'success'
                      });
                    });
                  } else if (_this16.dialogType === 'discForm') {
                    //盘次数管理
                    _this16.$refs["discForm"].validateField('amount', /*#__PURE__*/function () {
                      var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(valid) {
                        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              if (valid) isPass = false;
                            case 1:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      }));
                      return function (_x2) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                    var _params2 = {
                      quantity: _this16.discFormModel.amount,
                      group_store_id: _this16.formModel.id,
                      note: _this16.discFormModel.note ? _this16.discFormModel.note : ""
                      // store_devices: this.formModel.store_devices || []
                    };
                    (0, _group.updateStoreDisc)(_params2).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.isDiscShow = false;
                      _this16.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                    });
                  } else if (_this16.dialogType === 'deviceForm') {
                    //添加设备

                    var devices_disc = {
                      device_numbers: _this16.deviceFormModel.device_numbers ? _this16.deviceFormModel.device_numbers.split(",") : [],
                      disc_numbers: _this16.deviceFormModel.disc_numbers ? _this16.deviceFormModel.disc_numbers.split(",") : []
                    };
                    var _params3 = {
                      group_store_id: _this16.formModel.id,
                      devices_disc: devices_disc
                    };
                    (0, _group.createGroupStoreDevice)(_params3).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this16.errorHandle(res);
                      }
                      _this16.getList();
                      _this16.isDeviceShow = false;
                      _this16.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                    });
                  } else {
                    return;
                  }
                } else {
                  //验证不通过
                  _this16.$message({
                    showClose: true,
                    message: '信息未填写完整!请检查栏位提示',
                    type: 'warning'
                  });
                  return false;
                }
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this17 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          // 打API上传图片
          var formdata = new FormData();
          formdata.append('file', file);
          (0, _group.createStoreImage)(formdata).then(function (res) {
            _this17.previewImg = {
              // image: e.target.result, //直接读取
              urls: "".concat(res.data.urls),
              //从API res读取
              path: "".concat(res.data.path)
            };
          });
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeImg: function removeImg() {
      this.previewImg = {};
      this.formModel.license = '';
    },
    handleDelete: function handleDelete(scope) {
      var _this18 = this;
      return;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return deleteDoctor(scope.row.id);
            case 2:
              _this18.getList();
              _this18.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    getName: function getName() {
      var _this19 = this;
      if (this.managerAccount.length == 11) {
        var listQuery = {
          page: 1,
          page_size: this.listQuery.page_size,
          account: this.managerAccount
        };
        (0, _memberManage.getUsersList)(listQuery).then(function (response) {
          if (response.results.length > 0) {
            _this19.managerName = response.results[0].name;
            _this19.formModel.store_manager = response.results[0].account;
            // this.formModel.group_operator = response.results[0].id
            console.log('getUsersList managerAccount', _this19.managerAccount);
            console.log('getUsersList store_manager', _this19.formModel.store_manager);
          } else {
            _this19.$message({
              message: '请输入正确会员帐号(手机号)',
              type: 'warning'
            });
          }
          _this19.listLoading = false;
        });
      } else {
        this.$message({
          message: '请输入11位会员帐号(手机号)',
          type: 'warning'
        });
      }
    },
    getProvinceAll: function getProvinceAll() {
      var _this20 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this20.provinceData = response.data;
        // console.log('provinceData',this.provinceData)
      });
    },
    provinceChange: function provinceChange(val) {
      var _this21 = this;
      this.cityData = [];
      this.formModel.city_code = '';
      this.formModel.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this21.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.province_code === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this22 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this22.defaultCity = response.data;
        _this22.cityData = [];
        _this22.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this22.cityData.push(item_city);
        });
        // console.log('defaultCity',this.defaultCity)
        // console.log('cityData',this.cityData)
      });
    },
    cityChange: function cityChange(val) {
      var _this23 = this;
      this.districtData = [];
      this.formModel.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this23.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.city_code === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this24 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this24.defaultDistrict = response.data;
        _this24.districtData = [];
        _this24.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this24.districtData.push(item_district);
        });
      });
    },
    // 初始化资料处理
    handleInitData: function handleInitData() {
      var _this25 = this;
      // 图片重置赋值
      this.previewImg = {};
      this.previewImg = {
        urls: this.formModel.group_store_license_url
      };
      //审核备注清空
      this.stage1Comment = '';
      this.stage2Comment = '';
      //店长帐号/名称重置赋值(资料读取物件转字串)
      this.managerName = '';
      this.managerAccount = '';
      if (this.formModel.store_manager) {
        this.managerName = this.formModel.store_manager.name || '';
        this.managerAccount = this.formModel.store_manager.account || '';
        this.formModel.store_manager = this.formModel.store_manager.account || '';
      }
      //默认健管师重置赋值(资料读取物件转字串)
      // this.formModel.default_store_health_user=''
      if (this.formModel.default_store_health_user) {
        this.formModel.default_store_health_user = this.formModel.default_store_health_user.mobile || '';
      }
      console.log('handleInitData default_store_health_user', this.formModel.default_store_health_user);
      //检测设备为空阵列时初始化（一组物件可供填写）
      if (this.formModel.store_devices.length <= 0) {
        this.addDevice();
      }
      // 打开dialog时为每个设备的deviceL2Data数组分配与选中的L1选项相关联的L2选项
      this.formModel.store_devices.forEach(function (device, index) {
        var selectedL1 = device.device_category_level_1_code;
        if (selectedL1) {
          var associatedL2Options = _this25.deviceL2All.filter(function (item) {
            return item.category_level_1_code === selectedL1;
          });
          _this25.$set(device, 'deviceL2Data', (0, _toConsumableArray2.default)(associatedL2Options));
        } else {
          _this25.$set(device, 'deviceL2Data', []); // 如果没有选中的L1选项，则将deviceL2Data初始化为空数组
        }
      });
      if (JSON.stringify(this.formModel.store_health_users) == '[]') {
        this.formModel.store_health_users = [{
          name: ""
        }];
      }
      //默认健管师选项（不含新增尚未生成id的健管师）
      // if(this.formModel.store_health_users){
      //   this.healthUserList = {...this.formModel.store_health_users}
      //   console.log('healthUserList',this.healthUserList)
      // }
      // 如果审核备注为空给予初始值
      // if (!this.formModel.valid_records) {
      //   this.formModel.valid_records = [{ stage: 1, comment: '' },{ stage: 2, comment: '' }];
      // }
      // console.log('handleInitData valid_records',this.formModel.valid_records)
    },
    handleDisabled: function handleDisabled() {
      var isDisabled = true;
      // 非审核情况下，类型都不支持变更
      if (this.dialogType == 'review' || this.dialogType == 'approval') {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
      return isDisabled;
    },
    addMember: function addMember() {
      this.formModel.store_health_users.push({});
      console.log('addMember', this.formModel.store_health_users);
    },
    deleteMember: function deleteMember(item) {
      var _this26 = this;
      this.formModel.store_health_users.splice(this.formModel.store_health_users.indexOf(item), 1);
      this.$nextTick(function () {
        // this.$refs['Form'].clearValidate()
        _this26.formModel.store_health_users.forEach(function (item, index) {
          _this26.$refs['Form'].validateField("store_health_users.".concat(index));
        });
      });
    },
    addDevice: function addDevice() {
      // 为新添加的设备设置初始的deviceL2Data属性为空数组
      var newDevice = {
        device_category_level_1_code: '',
        device_category_level_2_code: '',
        device_number: '',
        device_description: '',
        deviceL2Data: []
      };
      this.formModel.store_devices.push(newDevice);
      console.log("addDevice", this.formModel.store_devices);
    },
    deleteDevice: function deleteDevice(item) {
      var _this27 = this;
      this.formModel.store_devices.splice(this.formModel.store_devices.indexOf(item), 1);
      this.$nextTick(function () {
        // this.$refs['Form'].clearValidate()
        _this27.formModel.store_devices.forEach(function (item, index) {
          _this27.$refs['Form'].validateField("store_devices.".concat(index));
        });
      });
    },
    // 操作盘次数管理
    handleDisc: function handleDisc(scope) {
      var _this28 = this;
      // this.resetForm()
      this.dialogType = 'discForm';
      this.discFormModel = JSON.parse(JSON.stringify(scope.row));
      this.formModel.id = scope.row.id;
      // this.formModel = this.handleRowData(scope.row)
      // this.handleRowData(scope.row)
      this.isDiscShow = true;
      this.$nextTick(function () {
        _this28.$refs['discForm'].clearValidate();
      });
    },
    // 操作添加设备
    handleDevice: function handleDevice(scope) {
      var _this29 = this;
      // this.resetForm()
      this.dialogType = 'deviceForm';
      this.deviceFormModel = JSON.parse(JSON.stringify(scope.row));
      this.formModel.id = scope.row.id;
      // this.formModel = this.handleRowData(scope.row)
      // this.handleRowData(scope.row)
      this.isDeviceShow = true;
      this.$nextTick(function () {
        _this29.$refs['deviceForm'].clearValidate();
      });
    },
    // handleExport() {
    // this.listLoading = true
    // const store = this.formModel.store_name;
    // const excelData = [
    //   ['操作时间', '会员帐号', '增减盘次数', '剩余盘次数', '备注']
    // ]
    // const query = { ...this.discRecordQuery }
    // query.page_size = 1000
    // getStoreDiscRecord(query).then(response => {
    //   this.table = response.results;
    //   for (let i = 0; i < this.table.length; i++) {
    //     this.rowData = [
    //       this.table[i].created_at,
    //       this.table[i].user,
    //       this.table[i].quantity,
    //       this.table[i].current_quantity,
    //       this.table[i].note
    //     ]
    //     excelData.push(this.rowData)
    //   }
    //   const ws = XLSX.utils.aoa_to_sheet(excelData)
    //   const wb = XLSX.utils.book_new()
    //   XLSX.utils.book_append_sheet(wb, ws, store)
    //   XLSX.writeFile(wb, '店铺盘次纪录.xlsx')
    //   this.listLoading = false
    // })
    // },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this30 = this;
        var _this, params, d, obj, totalCount, loop, store, excelData, _loop, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.listLoading = true;
              _this = this;
              params = {};
              d = Date.now();
              obj = {};
              totalCount = _this.discRecordQuery.count;
              loop = parseInt(totalCount / 2000);
              store = this.formModel.store_name;
              excelData = [['操作时间', '会员帐号', '增减盘次数', '剩余盘次数', '备注']];
              _loop = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop(i) {
                var query, item, rowData;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      query = (0, _objectSpread2.default)({}, _this30.discRecordQuery);
                      query.page = i;
                      query.page_size = 2000;
                      item = {};
                      rowData = [];
                      _context4.next = 7;
                      return (0, _group.getStoreDiscRecord)(query).then(function (response) {
                        item = response.results;
                        for (var j = 0; j < item.length; j++) {
                          rowData = [item[j].created_at, item[j].user, item[j].quantity, item[j].current_quantity, item[j].note];
                          excelData.push(rowData);
                        }
                        // var animalWS = XLSX.utils.json_to_sheet(excelData)
                        var ws = _xlsx.default.utils.aoa_to_sheet(excelData);
                        var wb = _xlsx.default.utils.book_new();
                        _xlsx.default.utils.book_append_sheet(wb, ws, store);
                        _xlsx.default.writeFile(wb, '店铺盘次纪录_' + i + '.xlsx');
                        excelData = [['操作时间', '会员帐号', '增减盘次数', '剩余盘次数', '备注']];
                      });
                    case 7:
                      _context4.next = 9;
                      return _this30.delay(1000);
                    case 9:
                    case "end":
                      return _context4.stop();
                  }
                }, _loop);
              });
              i = 1;
            case 11:
              if (!(i <= loop + 1)) {
                _context5.next = 16;
                break;
              }
              return _context5.delegateYield(_loop(i), "t0", 13);
            case 13:
              i++;
              _context5.next = 11;
              break;
            case 16:
              this.listLoading = false;
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    delay: function delay(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }
};